import React from 'react';
import {
  ExecutionDate,
  IdAndCreationDate,
  Marks,
  MasterAndExecuter,
  ParentServiceAndService,
  Status,
  Address,
  HistoryAndMap,
  CardsContainer,
} from '../../requestComponents';

export const requestColumns = [
  {
    title: '',
    key: 'mark',
    column: '1/2',
    fraction: '0.6fr',
    getCellStyles: () => ({
      gridColumn: '1/2',
      gridRow: '1/3',
      alignItems: 'flex-start',
      justifyContent: 'flex-start',
    }),
    getExpandedCellStyles: () => ({
      gridColumn: '1/2',
      gridRow: '3/4',
    }),
    renderItem: ({
      request,
      onBindCallToRequestSucces,
      onCreationMethodChange,
    }) => (
      <Marks
        request={request}
        rowExpanded
        onBindCallToRequestSucces={onBindCallToRequestSucces}
        onCreationMethodChange={onCreationMethodChange}
      />
    ),
    renderExpandedItem: ({ request }) => <HistoryAndMap request={request} />,
  },
  {
    title: '№/Создание',
    key: 'id/creationDate',
    column: '2/3',
    fraction: '1.1fr',
    getCellStyles: () => ({ gridColumn: '2/3', gridRow: '1/2' }),
    getExpandedCellStyles: () => ({
      gridColumn: '2/-1',
      gridRow: '2/4',
    }),
    renderItem: ({ request }) => <IdAndCreationDate request={request} />,
    renderExpandedItem: ({ request, canChange }) => (
      <CardsContainer
        request={request}
        canChange={canChange}
      />
    ),
  },
  {
    title: 'Статус',
    key: 'status',
    column: '3/4',
    fraction: '1fr',
    getCellStyles: () => ({
      gridColumn: '3/4',
      gridRow: '1/2',
      alignItems: 'flex-start',
    }),
    renderItem: ({
      request,
      onStatusChange,
      onCompletedStatusClick,
      canChange,
    }) => (
      <Status
        request={request}
        onStatusChange={onStatusChange}
        onCompletedStatusClick={onCompletedStatusClick}
        canChange={canChange}
      />
    ),
  },
  {
    title: 'Мастер/Исполнитель',
    key: 'master/executer',
    column: '4/5',
    fraction: '2fr',
    getCellStyles: () => ({ gridColumn: '4/5', gridRow: '1/2' }),
    renderItem: ({ request, canChange }) => (
      <MasterAndExecuter
        request={request}
        canChange={canChange}
      />
    ),
  },
  {
    title: 'Услуга/Причина',
    key: 'parentService/service',
    column: '5/6',
    fraction: '1.8fr',
    getCellStyles: () => ({ gridColumn: '5/6', gridRow: '1/2' }),
    renderItem: ({ request, canChange }) => (
      <ParentServiceAndService
        request={request}
        canChange={canChange}
      />
    ),
  },
  {
    title: 'Выполнение',
    key: 'executionDate',
    column: '6/7',
    fraction: '1.8fr',
    getCellStyles: () => ({ gridColumn: '6/7', gridRow: '1/2' }),
    renderItem: ({
      request,
      calendarIcon,
      onCalendarClick,
      onPriorityChange,
      canChange,
    }) => (
      <ExecutionDate
        request={request}
        calendarIcon={calendarIcon}
        onCalendarClick={onCalendarClick}
        onPriorityChange={onPriorityChange}
        canChange={canChange}
      />
    ),
  },
  {
    title: 'Адрес',
    key: 'address',
    column: '7/8',
    fraction: '1.7fr',
    getCellStyles: () => ({ gridColumn: '7/8', gridRow: '1/2' }),
    renderItem: ({ request, canChange }) => (
      <Address
        request={request}
        canChange={canChange}
      />
    ),
  },
];
